import React, { useEffect, useState, useRef } from 'react';
import MediaPlayer from '../utils/MediaPlayer';
import anime, { set } from 'animejs';
import '../css/common.css';
import '../css/button.css';
import ImageButton from '../utils/ImageButton';
import FramePlayer from '../utils/FramePlayer';
import lang from '../lang.json';

const Module5f6 = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module5f6;

    const [page, setPage] = useState(1);
    const [subpage, setSubpage] = useState(1);

    const audioPlayer = useRef();
    const duration = audioPlayer.current ? audioPlayer.current.duration : 0;
    const [musicPlaying, setMusicPlaying] = useState(false);
    const [musicTime, setMusicTime] = useState(0);
    const [selectedNote, setSelectedNote] = useState("1:1:1");
    const [isOrangeList, setIsOrangeList] = useState([]);

    const [hasStarted, setHasStarted] = useState(false);

    const offset = 1.63; // decalage initial en s

    const [hasChanged, setHasChanged] = useState(
        [
            false, false, false, false,
            false, false, false, false,
            false, false, false, false,
            false, false, false, false,
            false, false, false, false,
            false
        ]
    );

    const gridDuration = 12.53; // duree de 1 ligne
    const noteDuration = gridDuration / 16;
    const pageDuration = gridDuration * 3;

    function changementPageHandler(page, subpage) {
        setPage(page);
        setSubpage(subpage);
        //We need to chnage the music time
        let time = (page - 1) * pageDuration + (subpage - 1) * gridDuration + offset;
        audioPlayer.current.currentTime = time;
        resetTo(time);
    }
    function changementPageHandler2(page, subpage) {
        setPage(page); //PB27
        setSubpage(subpage);
    }

    const notesList = ["F7", "A7", "Ab7M", "D7", "Bb7", "E7", "Eb7", "D7", ""]

    const notes =
        [
            [
                ["F7", "", "Db7", "", "Gb7M", "", "B7", "", "Eb7", "", "Db7", "", "Eb7", "", "F7", ""],
                ["Bbm7", "", "Ab7", "", "Gm7", "", "C7", "", "D7", "", "G7", "", "Db7", "", "Gb7M", ""],
                ["Bb7", "", "Db7", "", "C7", "", "Eb7", "", "F7", "", "Db7", "", "Gb7M", "", "B7", ""],
            ],
            [
                ["Eb7", "", "D7", "Ab7", "G7", "Gb7", "F7", "", "E7", "Eb7", "Db7", "", "Eb7", "", "F7", ""],
                ["Bbm7", "", "Ab7", "", "Gm7", "", "C7", "", "D7", "", "G7", "", "Db7", "", "Gb7M", ""],
                ["Bb7", "", "Db7", "", "C7", "", "Eb7", "", "F7", "", "Db7", "", "Gb7M", "", "B7", ""],
            ],
            [
                ["D7", "", "D7", "A7", "Ab7", "G7", "Gb7", "E7", "Eb7", "", "Db7", "", "Eb7", "", "F7", ""],
                ["Bbm7", "", "Ab7", "", "Gm7", "", "C7", "", "D7", "", "G7", "", "Db7", "", "Gb7M", ""],
                ["Bb7", "", "Db7", "", "C7", "", "Eb7", "", "F7", "", "Db7", "", "Gb7M", "", "B7", ""],
            ],
            [
                ["D7", "", "Eb7M", "A7", "Ab7", "G7", "Gb7", "A7", "Ab7", "", "E7", "", "Db7", "", "C7", "B7"],
                ["Bb7", "A7", "A7", "Ab7", "Gm7", "", "C7", "", "D7", "", "G7", "", "Db7", "", "Gb7M", ""],
                ["Bb7", "", "Db7", "", "C7", "", "Eb7", "", "F7", "", "Db7", "", "Gb7M", "", "B7", ""],
            ],
            [
                ["Eb7", "", "D7", "", "Db7", "C7", "E7", "", "A7", "", "Ab7", "Bb7", "Bb7", "G7", "Gb7", "F7"],
                ["B7M", "Eb7", "A7", "Ab7", "Gm7", "", "C7", "", "D7", "", "G7", "", "Db7", "", "Gb7M ", ""],
                ["Bb7", "", "Db7", "", "C7", "", "Eb7", "", "F7", "", "Db7", "", "Gb7M", "", "B7", ""],
            ],
        ]

    const notesAfterChange =
        [
            [
                ["Ab7", "", "G7", "", "Gb7", "F7", "E7", "", "E7", "Eb7", "Bb7", "", "C7M", "Gb7", "Gb7", "F7"],
                ["B7M", "Bbm7", "A7", "", "Ab7M", "D7", "Db7", "Eb7", "Ab7", "", "Ab7", "", "G7", "", "Gb7", "F7"],
                ["B7", "Eb7", "D7", "", "Db7", "G7", "Gb7", "", "D7", "", "G7M", "Db7", "C7", "", "B7", ""],
            ],
            [
                ["Eb7", "", "D7", "Ab7", "G7", "Gb7", "F7", "", "E7", "Eb7", "G7", "", "Gb7", "", "Gb7", "F7"],
                ["B7M", "A7", "C7", "", "B7", "Bb7", "A7", "", "Ab7", "", "D7", "", "D7", "Db7", "B7", ""],
                ["D7", "", "D7", "Db7", "F7", "", "E7", "G7", "Gb7", "D7", "Eb7", "D7", "Db7", "C7", "B7", ""],
            ],
            [
                ["D7", "", "D7", "A7", "Ab7", "G7", "Gb7", "E7", "Eb7", "D7", "D7", "", "G7", "", "C7", ""],
                ["B7M", "Bb7", "A7", "Ab7", "Ab7M", "Db7", "Db7", "C7", "Ab7", "", "D7", "", "D7", "Ab7", "G7", "Gb7"],
                ["F7", "D7", "D7", "", "Db7", "C7", "C7M", "Gb7", "Eb7", "D7", "Eb7", "D7", "Db7", "C7", "B7", ""],
            ],
            [
                ["D7", "", "Eb7M", "A7", "Ab7", "G7", "Gb7", "A7", "Ab7", "", "E7", "", "Db7", "", "C7", "B7"],
                ["Bb7", "A7", "A7", "Ab7", "Ab7", "", "G7", "Bb7", "A7", "Ab7", "D7", "", "D7", "Db7", "A7", ""],
                ["Ab7", "", "Eb7", "D7", "Db7", "G7", "Gb7", "", "Eb7", "", "D7", "", "Db7", "C7", "B7", ""],
            ],
            [
                ["Eb7", "", "D7", "", "Db7", "C7", "E7", "", "A7", "", "Ab7", "Bb7", "Bb7", "G7", "Gb7", "F7"],
                ["B7M", "Eb7", "A7", "Ab7", "Ab7M", "G7", "G7", "A7", "Ab7", "", "Eb7", "", "D7", "Db7", "C7", "B7"],
                ["B7", "Ab7", "G7", "", "Gb7", "F7", "E7", "C7", "Gb7", "Eb7", "D7", "", "Db7", "C7", "B7", ""],
            ],
        ]

    function getCurrentNoteFromTime(time) {
        let page = Math.floor(time / pageDuration);
        let grid = Math.floor((time - pageDuration * page) / gridDuration);
        let note = Math.floor(((time - pageDuration * page - gridDuration * grid)) / noteDuration);
        return `${page + 1}:${grid + 1}:${note + 1}`;
    }

    function createGrids(id) {
        //16 notes / 3 lines
        let grid = [];
        for (let i = 0; i < 3; i++) {
            grid.push(
                <div
                    key={`grid${id}${i + 1}`}
                    id={`grid${id}${i + 1}`}
                    style={{
                        position: 'absolute',
                        top: `${i * 147 + 125}px`,
                        left: '10px',
                        width: '647px',
                        height: '40px',
                        display: 'flex',
                        flexDirection: 'line',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        alignContent: 'center',
                        border: '2px solid white',
                        backgroundColor: "black",
                        opacity: page == id ? 1 : 0,
                    }}>
                    {
                        notes[id - 1][i].map((note, index) => {
                            let bg = 'transparent'
                            let noteIndex = selectedNote.split(":")[2];
                            let gridIndex = selectedNote.split(":")[1];
                            let pageIndex = selectedNote.split(":")[0];
                            let mapping = [
                                [1, 2, 3, 4],
                                [5, 6, 7, 8],
                                [9, 10, 11, 12],
                                [13, 14, 15, 16],
                            ]
                            let g = Math.min(Math.max(Math.floor((noteIndex - 1) / 4), 0), 3);
                            let noteIndexMapping = mapping[g];
                            if (isOrangeList.includes(`${id}:${i + 1}:${index + 1}`)) {
                                bg = '#fc733d';
                            }
                            else if (noteIndexMapping.includes(index + 1) && pageIndex == id && gridIndex == i + 1) {
                                bg = 'blue';
                            }

                            return (
                                <div
                                    key={`${id}:${i + 1}:${index + 1}`}
                                    id={`${id}:${i + 1}:${index + 1}`}
                                    style={{
                                        position: 'relative',
                                        width: '100%',
                                        height: '100%',
                                        borderRight: index % 4 === 3 && index != 18 ? '2px solid white' : 'none',
                                        margin: '0px',
                                        backgroundColor: bg,
                                    }}>
                                    <p
                                        style={{
                                            position: 'absolute',
                                            top: '-4px',
                                            left: '3px',
                                            width: '100%',
                                            height: '100%',
                                            textAlign: 'left',
                                            fontSize: '15px',
                                            color: "white",
                                        }}>
                                        {note}
                                    </p>
                                </div>
                            )
                        }
                        )
                    }
                </div >
            )
        }
        return grid;
    }

    function createPianos(id) {
        let pianos = [];
        for (let i = 0; i < 3; i++) {
            let showP = "0%"
            let startTime = (id - 1) * pageDuration + i * gridDuration + offset;
            let endTime = startTime + gridDuration + offset;
            if (musicTime < startTime) {
                showP = "0%"
            } else if (musicTime >= endTime) {
                showP = "100%"
            } else {
                showP = `${Math.min((musicTime - startTime) / gridDuration * 100, 100)}%`
            }

            pianos.push(
                <div
                    style={{
                        position: 'absolute',
                        top: `${i * 148 + 25}px`,
                        left: '0px',
                        opacity: page == id ? 1 : 0,
                    }}
                    key={`piano${id}${i + 1}`}
                    id={`piano${id}${i + 1}`}>
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/module5f6/pianokey.png"} alt="piano"
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                        }}
                    />
                    <div
                        className='pianoContainer'
                        style={{
                            position: 'absolute',
                            top: "0px",
                            left: "10px",
                            height: "100px",
                            width: "650px",
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + `/assets/images/module5f6/${id}${i + 1}.jpg`} alt="piano"
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                width: showP,
                                height: '100%',
                                objectFit: 'cover',
                                objectPosition: 'left',
                            }}
                        />
                    </div>

                </div>
            )
        }
        return pianos;
    }

    function randomRoll(id, grid, note) {
        //Draw a random note from noteList
        const RNote = notesList[Math.floor(Math.random() * notesList.length)];
        let element = document.getElementById(`${id}:${grid}:${note}`);
        element.innerHTML = '<p style="position:absolute;top:-4px;left:3px;width:100%;height:100%;text-align:left;font-size:15px;color:white;">' + RNote + '</p>';
    }

    function randomRollMultiple(duration, noteList) {
        for (let i = 0; i < noteList.length; i++) {
            let id = noteList[i].split(":")[0];
            let grid = noteList[i].split(":")[1];
            let note = noteList[i].split(":")[2];
            const interval = 150
            for (let i = 0; i < duration / interval; i++) {
                setTimeout(() => {
                    randomRoll(id, grid, note);
                }, interval * i);
            }
        }
    }

    function updateNotes(begin, end) {
        let noteList = [];
        let id = begin.split(":")[0];
        let grid = begin.split(":")[1];
        let note = begin.split(":")[2];
        let endId = end.split(":")[0];
        let endGrid = end.split(":")[1];
        let endNote = end.split(":")[2];
        for (let i = id; i <= endId; i++) {
            for (let j = (i == id ? grid : 1); j <= (i == endId ? endGrid : 3); j++) {
                for (let k = (j == grid ? note : 1); k <= (j == endGrid ? endNote : 16); k++) {
                    noteList.push(`${i}:${j}:${k}`);
                    //After the duration, remove the note from the isOrangeList and set the note to notesAfterChange
                    setTimeout(() => {
                        setIsOrangeList(isOrangeList.filter((item) => item != `${i}:${j}:${k}`));
                        let element = document.getElementById(`${i}:${j}:${k}`);
                        element.innerHTML = '<p style="position:absolute;top:-4px;left:3px;width:100%;height:100%;text-align:left;font-size:15px;color:white;">' + notesAfterChange[i - 1][j - 1][k - 1] + '</p>';
                        console.log(`note chnaged to ${notesAfterChange[i - 1][j - 1][k - 1]}`)
                    }, 1600);
                }
            }
        }
        //for each note in noteList
        //Add noteList to isOrangeList
        setIsOrangeList(isOrangeList.concat(noteList));
        randomRollMultiple(1500, noteList);
    }

    const changeTimecode = [
        6.23, 12.46, 32.71, 35.82, 43.61, 59.19, 63.86, 73.2, 79.43, 88.78, 102.8, 110.58, 126.16, 133.95, 147.96, 163.54, 172.88
    ]

    function resetTo(time) {
        setMusicTime(time);
        setIsOrangeList([]);
        //Calculate the new hasChanged list
        let newHasChanged = [];
        for (let i = 0; i < changeTimecode.length; i++) {
            if (changeTimecode[i] < time) {
                newHasChanged.push(true);
            } else {
                newHasChanged.push(false);
            }
        }
        //setHasChanged(newHasChanged);
        //Update the notes
        if (time < offset) return;
        let note = getCurrentNoteFromTime(time - offset + 0.01);
        let id = note.split(":")[0];
        let grid = note.split(":")[1];
        let noteId = note.split(":")[2];
        for (let i = id; i <= 5; i++) {
            for (let j = (i == id ? grid : 1); j <= 3; j++) {
                for (let k = 1; k <= 16; k++) {
                    let element = document.getElementById(`${i}:${j}:${k}`);
                    element.innerHTML = '<p style="position:absolute;top:-4px;left:1px;width:100%;height:100%;text-align:left;font-size:15px;color:white;">' + notes[i - 1][j - 1][k - 1] + '</p>';
                }//PGBG7M
            }
        }
    }


    function createPageButtons() {
        //Create page buttons : 5 page
        //Each page has 2 subpage buttons
        //The page button is an img src="circle.svg"
        //Smaller for subpage buttons
        let pageButtons = [];
        for (let i = 1; i <= 5; i++) {
            pageButtons.push(
                <div
                    key={i}>
                    <div
                        onMouseEnter={
                            (e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/module5f6/circle_clicked.svg";
                            }
                        }
                        onMouseLeave={
                            (e) => {
                                if (page != i || subpage != 1) {
                                    e.target.src = process.env.PUBLIC_URL + "/assets/images/module5f6/circle.svg";
                                }
                            }
                        }
                        onClick={
                            (e) => {
                                changementPageHandler(i, 1);
                            }
                        }>
                        <img
                            style={{ position: 'absolute', top: '-8px', left: `${i * 70}px`, width: "22px", zIndex: 3 }}//PB-non répertorié
                            src=
                            {page == i && subpage == 1 ?
                                process.env.PUBLIC_URL + "/assets/images/module5f6/circle_clicked.svg" :
                                process.env.PUBLIC_URL + "/assets/images/module5f6/circle.svg"}
                            alt="page"
                            id={`page${i}`}

                        />
                        <p
                            style={{
                                position: 'absolute',
                                top: '-24px',
                                left: `${i * 70 + 6}px`,
                                color: 'white',
                                zIndex: 3,
                                userSelect: 'none',
                            }}
                        >
                            {i}
                        </p>
                    </div>

                    <img
                        style={{ position: 'absolute', top: '2px', left: `${i * 70 + 25}px`, width: "14px", zIndex: 3 }}
                        src=
                        {page == i && subpage == 2 ?
                            process.env.PUBLIC_URL + "/assets/images/module5f6/circle_clicked.svg" :
                            process.env.PUBLIC_URL + "/assets/images/module5f6/circle.svg"} alt="page"
                        id={`page${i}`}
                        onMouseEnter={
                            (e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/module5f6/circle_clicked.svg";
                            }
                        }
                        onMouseLeave={
                            (e) => {
                                if (page != i || subpage != 2) {
                                    e.target.src = process.env.PUBLIC_URL + "/assets/images/module5f6/circle.svg";
                                }
                            }
                        }
                        onClick={
                            (e) => {
                                changementPageHandler(i, 2);
                            }
                        }
                    />
                    <img
                        style={{ position: 'absolute', top: '2px', left: `${i * 70 + 42}px`, width: "14px", zIndex: 3 }}
                        src=
                        {page == i && subpage == 3 ?
                            process.env.PUBLIC_URL + "/assets/images/module5f6/circle_clicked.svg" :
                            process.env.PUBLIC_URL + "/assets/images/module5f6/circle.svg"}
                        alt="page"
                        id={`page${i}`}
                        onMouseEnter={
                            (e) => {
                                e.target.src = process.env.PUBLIC_URL + "/assets/images/module5f6/circle_clicked.svg";
                            }
                        }
                        onMouseLeave={
                            (e) => {
                                if (page != i || subpage != 3) {
                                    e.target.src = process.env.PUBLIC_URL + "/assets/images/module5f6/circle.svg";
                                }
                            }
                        }
                        onClick={
                            (e) => {
                                changementPageHandler(i, 3);
                            }
                        }
                    />
                </div>
            );
        }
        return pageButtons;
    }



    useEffect(() => {
        //Fade in image 1
        let tl = anime.timeline({
        });
        tl.add({
            targets: '#image1',
            opacity: 1,
            easing: 'easeInOutQuint',
            duration: 3000,
        }, 3000)
            //Fade out image 1
            //Fade in image 2
            .add({
                targets: '#image1',
                opacity: 0,
                easing: 'easeInOutQuint',
                duration: 3000,
            }, 3000)
            .add({
                targets: '#image2',
                opacity: 1,
                easing: 'easeInOutQuint',
                duration: 3000,
            }, 3000)
            //Fade out image 2
            //Fade in image 3
            .add({
                targets: '#image2',
                opacity: 0,
                easing: 'easeInOutQuint',
                duration: 3000,
            }, 9000)
            .add({
                targets: '#image3',
                opacity: 1,
                easing: 'easeInOutQuint',
                duration: 3000,
            }, 9000)
            //Fade out image 3
            .add({
                targets: '#image3',
                opacity: 0.9,
                easing: 'easeInOutQuint',
                duration: 3000,
            }, 12000)
            .add({
                targets: '#anim',
                opacity: 1,
                easing: 'easeInOutQuint',
                duration: 3000,
            }, 12000)
            .add({
                targets: '.t1',
                opacity: 1,
                easing: 'easeInOutQuint',
                duration: 1500,
            }, 12500)

        //play a mp3 file
        var audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module5f6.mp3");
        audio.play();
        props.audio.push(audio)

        //sous titres
        let tl2 = anime.timeline({})
        //dabord opacity 0 pour tous
        tl2.add({
            targets: '.st',
            opacity: 0,
            duration: 1,
        })
            .add({
                targets: '.st1',
                opacity: 1,
                duration: 1,
            }, 500)
            .add({
                targets: '.st1',
                opacity: 0,
                duration: 1,
            }, 12000)
    }, []);

    useEffect(() => {
        /*
        Update is too slow for the timeupdate event
        audioPlayer.current.addEventListener('timeupdate', () => {
            setMusicTime(audioPlayer.current.currentTime);
        });*/
        setInterval(function () {
            setMusicTime(audioPlayer.current.currentTime);
        }, 30);
    }, []);

    const playMusic = () => {
        audioPlayer.current.play();
        setMusicPlaying(true);
    }

    const pauseMusic = () => {
        audioPlayer.current.pause();
        setMusicPlaying(false);
    }

    const reset = () => {
        audioPlayer.current.currentTime = 0;
        resetTo(0);
        pauseMusic();
    }

    useEffect(() => {
        if (musicTime > offset) {
            let note = getCurrentNoteFromTime(musicTime - offset);
            if (note != selectedNote) {
                setSelectedNote(note);
            }
            //next page if needed
            let pageReq = note.split(':')[0];
            if (page != pageReq) {
                changementPageHandler2(pageReq, 1);
            }
        }

        //Launch update of the note if needed
        if (musicTime >= 0.01 && hasChanged[0] == false) {
            updateNotes("1:1:1", "1:1:10");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[0] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 6.23 && hasChanged[1] == false) {
            updateNotes("1:1:11", "1:2:2");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[1] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 12.46 && hasChanged[2] == false) {
            updateNotes("1:2:3", "1:3:14");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[2] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 32.71 && hasChanged[3] == false) {
            updateNotes("1:3:13", "1:3:14");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[3] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 35.82 && hasChanged[4] == false) {
            updateNotes("1:1:1", "1:1:10");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[4] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 43.61 && hasChanged[5] == false) {
            updateNotes("2:1:11", "2:2:14");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[5] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 59.19 && hasChanged[6] == false) {
            updateNotes("2:2:15", "2:3:4");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[6] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 63.86 && hasChanged[7] == false) {
            updateNotes("2:3:5", "2:3:14");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[7] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 73.2 && hasChanged[8] == false) {
            updateNotes("2:1:1", "2:1:10");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[8] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 79.43 && hasChanged[9] == false) {
            updateNotes("3:1:9", "3:2:4");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[9] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 88.78 && hasChanged[10] == false) {
            updateNotes("3:2:5", "3:3:6");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[10] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 102.8 && hasChanged[11] == false) {
            updateNotes("3:3:7", "3:3:14");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[11] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 110.58 && hasChanged[12] == false) {
            updateNotes("3:1:1", "3:2:4");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[12] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 126.16 && hasChanged[13] == false) {
            updateNotes("4:2:5", "3:2:14");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[13] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 133.95 && hasChanged[14] == false) {
            updateNotes("4:2:15", "4:3:14");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[14] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 147.96 && hasChanged[15] == false) {
            updateNotes("4:1:1", "4:2:4");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[15] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 163.54 && hasChanged[16] == false) {
            updateNotes("5:2:5", "5:2:14");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[16] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= 172.88 && hasChanged[17] == false) {
            updateNotes("5:2:15", "5:3:14");
            let hasChangedCopy = hasChanged;
            hasChangedCopy[17] = true;
            setHasChanged(hasChangedCopy)
        }
        if (musicTime - offset >= pageDuration * 5) {
            resetTo(0);
        }

    }, [musicTime]);

    return (
        <>
            <div className="background">
                <div className="imagesintro"
                    style={{ position: 'absolute', top: '0px', left: '0px', zIndex: 2 }}>
                    <img
                        style={{ position: 'absolute', top: '0px', left: '0px', opacity: 1, zIndex: 2 }}
                        src={process.env.PUBLIC_URL + "/assets/images/module5f6/1.jpg"} alt="background" id="image1" />
                    <img
                        style={{ position: 'absolute', top: '0px', left: '0px', opacity: 0, zIndex: 2 }}
                        src={process.env.PUBLIC_URL + "/assets/images/module5f6/2.jpg"} alt="background" id="image2" />
                    <img
                        style={{ position: 'absolute', top: '0px', left: '0px', opacity: 0, zIndex: 2 }}
                        src={process.env.PUBLIC_URL + "/assets/images/module5f6/3.jpg"} alt="background" id="image3" />
                </div>

                <div id="anim"
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        zIndex: 3,
                        opacity: 0
                    }}>
                    <div className='gridsPanel'>
                        {createPianos(1)}
                        {createGrids(1)}
                        {createPianos(2)}
                        {createGrids(2)}
                        {createPianos(3)}
                        {createGrids(3)}
                        {createPianos(4)}
                        {createGrids(4)}
                        {createPianos(5)}
                        {createGrids(5)}
                    </div>
                    <div className="buttons"
                        style={{ position: 'absolute', top: '478px', left: '12px', zIndex: 3 }}>
                        {/* play button */}
                        <img
                            style={{ position: 'absolute', top: '0px', left: '0px', zIndex: 3 }}
                            src={process.env.PUBLIC_URL + `/assets/images/module5f6/play${musicPlaying ? "2" : ""}.png`} alt="play" id="play"
                            onClick={() => { playMusic(); setHasStarted(true); }}
                            onMouseEnter={
                                (e) => {
                                    if (!musicPlaying) {
                                        e.target.src = process.env.PUBLIC_URL + "/assets/images/module5f6/play2.png";
                                    }
                                }
                            }
                            onMouseLeave={
                                (e) => {
                                    if (!musicPlaying) {
                                        e.target.src = process.env.PUBLIC_URL + "/assets/images/module5f6/play.png";
                                    }
                                }
                            }
                        />
                        {/* pause button */}
                        <img
                            style={{ position: 'absolute', top: '0px', left: '25px', zIndex: 3 }}
                            src={process.env.PUBLIC_URL + `/assets/images/module5f6/pause${!musicPlaying ? "2" : ""}.png`} alt="pause" id="pause"
                            onClick={() => { pauseMusic(); }}
                            onMouseEnter={
                                (e) => {
                                    if (musicPlaying) {
                                        e.target.src = process.env.PUBLIC_URL + "/assets/images/module5f6/pause2.png";
                                    }
                                }
                            }
                            onMouseLeave={
                                (e) => {
                                    if (musicPlaying) {
                                        e.target.src = process.env.PUBLIC_URL + "/assets/images/module5f6/pause.png";
                                    }
                                }
                            }
                        />
                        {/* back button */}
                        <img
                            style={{ position: 'absolute', top: '0px', left: '50px', zIndex: 3 }}
                            src={process.env.PUBLIC_URL + "/assets/images/module5f6/back2.png"} alt="stop" id="stop"
                            onClick={() => { reset(); console.log("reset"); }}
                            onMouseEnter={
                                (e) => {
                                    e.target.src = process.env.PUBLIC_URL + "/assets/images/module5f6/back2.png";
                                }
                            }
                            onMouseLeave={
                                (e) => {
                                    e.target.src = process.env.PUBLIC_URL + "/assets/images/module5f6/back.png";
                                }
                            }
                        />
                        {/* page buttons */}
                        <div className="pageButtons"
                            style={{ position: 'absolute', top: '0px', left: '0px', zIndex: 3 }}
                        >
                            {createPageButtons()}
                        </div>
                    </div>
                    <audio
                        id="audio"
                        src={process.env.PUBLIC_URL + "/assets/sounds/musique_module5f6.mp3"}
                        controls
                        style={{ display: 'none', position: 'absolute' }}
                        ref={audioPlayer} />
                </div>
                <div
                    style={{
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        zIndex: 4,
                        color: 'white',
                    }}
                >
                    {/*
                    {musicTime} <br />
                    {getCurrentNoteFromTime(musicTime)}
                */}
                </div>

                {/* textes */}
                <p
                    style={{
                        position: 'absolute',
                        left: 10,
                        top: 4,
                        color: 'white',
                        fontSize: '15px',
                        margin: 0,
                        zIndex: 15
                    }}
                >{texts.lang1}</p>

                {/* sous titres */}
                <p
                    className="st1 st"
                    style={{
                        position: 'absolute',
                        top: '400px',
                        left: '10px',
                        width: '600px', //PB26
                        zIndex: 2,
                        opacity: 1,
                        color: 'white',
                        backgroundColor: 'black',
                        backgroundOpacity: 0.5,
                        padding: '5px',
                    }}
                >
                    {texts.lang24}
                </p>
                <p
                    className="t1 text"
                    style={{
                        position: 'absolute',
                        top: '5px',
                        left: '20px',
                        opacity: 0,
                        width: '580px', //PB26
                        color: 'white',
                        fontSize: '16px',
                        padding: '5px',
                        zIndex: 3,
                        display: hasStarted ? 'none' : 'block',
                    }}
                >
                    {texts.lang30}
                </p>
            </div>
        </>
    );
}

export default Module5f6;
